import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';

import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import LockIcon from '@material-ui/icons/Lock';

import './App.css';
import 'fontsource-roboto';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    minHeight: '99vh'
  },
  centered: {
    minHeight: '100vh'
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
}));

function App() {
  const classes = useStyles();
  const appendix = window.location.pathname.substr(-1) === '/' ? 'azure' : '/azure';
  const params = new URLSearchParams(window.location.search);
  const redirect_to = params.get("redirect_to");
  console.log(`redirect_to is ${redirect_to}`);

  return (
    <Grid container spacing={3} className={classes.root} direction="column" justify="center" alignItems="center">
      <Grid item xs={12}>
        <Typography variant="h4" gutterBottom>
          Restricted realm
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h6" gutterBottom>
          Available authentication methods
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Button variant="contained" color="primary" startIcon={<LockIcon />} size="large" onClick={() => { window.location.replace(`${window.location.origin + window.location.pathname}${appendix}` + (redirect_to ? `?redirect_to=${encodeURIComponent(redirect_to)}` : '')) }}>
          Azure
        </Button>
      </Grid>
    </Grid>
  );
}

export default App;
